import { useState, useEffect } from "react";
import { PanelNav } from "../Bootoverlay/Bootoverlay";

const PACKAGES = [
    {
        id: "recon",
        code: "01",
        name: "RECON",
        headcount: "10–20",
        duration: "2 HRS",
        price: "$1,800",
        color: "var(--vk-blue)",
        colorHex: "#00D4FF",
        features: ["Private track session", "Safety briefing & gear", "Timed leaderboard", "Digital results"],
    },
    {
        id: "assault",
        code: "02",
        name: "ASSAULT",
        headcount: "20–50",
        duration: "4 HRS",
        price: "$4,200",
        color: "var(--vk-orange)",
        colorHex: "#FF3800",
        features: ["Venue buyout", "Custom liveries", "Tournament bracket", "Open bar + catering", "Trophy ceremony"],
        hot: true,
    },
    {
        id: "blacksite",
        code: "03",
        name: "BLACKSITE",
        headcount: "50–200",
        duration: "FULL DAY",
        price: "CUSTOM",
        color: "var(--vk-lime)",
        colorHex: "#A3E635",
        features: ["Full venue takeover", "Branded experience", "Pro driver appearance", "Live DJ + commentary", "Executive lounge"],
    },
];

const STATS = [
    { v: "500+", l: "EVENTS" },
    { v: "12K+", l: "DRIVERS" },
    { v: "98%", l: "REBOOK" },
    { v: "4.9★", l: "RATING" },
];

const TESTIMONIALS = [
    '"Best off-site we\'ve done. The team bonded more in 2 hours than a year of standups."',
    '"ASSAULT package ran like clockwork. The trophy ceremony sealed Q3."',
    '"Closed three deals on the track. This is our annual client event now."',
];

const TESTIMONIAL_CREDIT = [
    "VP ENG · TIER-1 TECH CO.",
    "HEAD OF SALES · FINANCE GROUP",
    "MANAGING DIR · REAL ESTATE",
];

const STEPS = [
    { n: "01", t: "SUBMIT", d: "Fill brief. We respond in 24hrs." },
    { n: "02", t: "PLAN", d: "Custom track day built for you." },
    { n: "03", t: "RACE", d: "Arrive, gear up, full throttle." },
    { n: "04", t: "DEBRIEF", d: "Results + reel in 48hrs." },
];

export default function PanelCorporate({ onNav }) {
    const [active, setActive] = useState(1);
    const [view, setView] = useState("packages");
    const [form, setForm] = useState({ company: "", email: "", headcount: "", notes: "" });
    const [sent, setSent] = useState(false);

    const pkg = PACKAGES[active];

    return (
        <section className="vk-panel vk-cp" id="panel-event">

            {/* ── BG ── */}
            <div className="vk-cp-bg" aria-hidden="true">
                <div className="vk-cp-grid-lines" />
                <div className="vk-cp-glow" style={{ background: `radial-gradient(ellipse at 70% 40%, ${pkg.colorHex}0D 0%, transparent 60%)` }} />
                <div className="vk-cp-left-bar" />
            </div>

            {/* ══ TOP BAR ══ */}
            <div className="vk-cp-topbar">
                <div className="vk-section-eyebrow" style={{ margin: 0 }}>
                    <span className="vk-eyebrow-num">08</span>
                    <span>//</span>
                    <span>CORPORATE EVENTS &amp; PRIVATE PARTIES</span>
                </div>
                <div className="vk-cp-pulse-dot" />
            </div>

            {/* ══ MAIN GRID ══ */}
            <div className="vk-cp-grid">

                {/* ─── LEFT ─── */}
                <div className="vk-cp-left">
                    <span className="vk-cp-eyebrow" style={{ color: "var(--vk-orange)" }}>// MISSION TIER</span>

                    <div className="vk-cp-pkg-list">
                        {PACKAGES.map((p, i) => (
                            <button
                                key={p.id}
                                className={`vk-cp-pkg-btn${active === i && view === "packages" ? " active" : ""}`}
                                style={active === i && view === "packages" ? {
                                    borderColor: p.colorHex,
                                    borderLeftColor: p.colorHex,
                                } : {}}
                                onClick={() => { setActive(i); setView("packages"); }}
                            >
                                <div className="vk-cp-pkg-btn-row">
                                    <span
                                        className="vk-cp-pkg-btn-name"
                                        style={{ color: active === i && view === "packages" ? p.colorHex : undefined }}
                                    >
                                        {p.name}
                                    </span>
                                    {p.hot && (
                                        <span className="vk-cp-pkg-hot" style={{ color: p.colorHex, borderColor: p.colorHex }}>
                                            HOT
                                        </span>
                                    )}
                                </div>
                                <div className="vk-cp-pkg-btn-sub">{p.headcount} · {p.duration}</div>
                            </button>
                        ))}
                    </div>

                    <div className="vk-cp-stats">
                        {STATS.map((s, i) => (
                            <div key={i} className="vk-cp-stat">
                                <div className="vk-cp-stat-val" style={{ color: "var(--vk-orange)" }}>{s.v}</div>
                                <div className="vk-cp-stat-lbl">{s.l}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ─── CENTER ─── */}
                <div className="vk-cp-center">
                    {/* 3D Ghost Text — double layer like the hero */}
                    <div className="vk-cp-ghost" aria-hidden="true">
                        <span
                            className="vk-cp-ghost-shadow"
                            style={{ WebkitTextStroke: `2.5px ${pkg.colorHex}38` }}
                        >
                            {view === "contact" ? "BOOK" : pkg.name}
                        </span>
                        <span
                            className="vk-cp-ghost-main"
                            style={{ color: `${pkg.colorHex}12` }}
                        >
                            {view === "contact" ? "BOOK" : pkg.name}
                        </span>
                    </div>

                    {/* PACKAGES VIEW */}
                    {view === "packages" && (
                        <div key={`p${active}`} className="vk-cp-fade">
                            <span className="vk-cp-eyebrow" style={{ color: "var(--vk-blue)" }}>
                                ◉ PACKAGE {pkg.code} / 03
                            </span>

                            <h1 className="vk-cp-pkg-heading">
                                {pkg.name}<br />
                                <span style={{ color: pkg.colorHex }}>PACKAGE</span>
                            </h1>

                            <div className="vk-cp-price-row">
                                <span className="vk-cp-price" style={{ color: pkg.colorHex }}>{pkg.price}</span>
                                <span className="vk-cp-price-meta">{pkg.headcount} DRIVERS · {pkg.duration}</span>
                            </div>

                            <div className="vk-cp-chips">
                                {pkg.features.map((f, i) => (
                                    <span
                                        key={i}
                                        className="vk-cp-chip"
                                        style={{
                                            background: `${pkg.colorHex}10`,
                                            borderColor: `${pkg.colorHex}35`,
                                            color: "var(--vk-text-muted)",
                                        }}
                                    >
                                        {f}
                                    </span>
                                ))}
                            </div>

                            <button
                                className="vk-cp-cta-btn"
                                style={{ background: pkg.colorHex, color: "#060810" }}
                                onClick={() => setView("contact")}
                            >
                                BOOK {pkg.name} ▶
                            </button>
                        </div>
                    )}

                    {/* CONTACT VIEW */}
                    {view === "contact" && (
                        <div key="contact" className="vk-cp-fade">
                            {sent ? (
                                <div className="vk-cp-success">
                                    <div className="vk-cp-success-icon">✓</div>
                                    <span className="vk-cp-eyebrow" style={{ color: "var(--vk-lime)", textAlign: "center", display: "block" }}>
                    // TRANSMISSION RECEIVED
                                    </span>
                                    <h2 className="vk-cp-contact-heading">BRIEF INCOMING</h2>
                                    <p className="vk-cp-success-body">
                                        Our events team will contact you within 24 hours to lock in your deployment.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <span className="vk-cp-eyebrow" style={{ color: "var(--vk-orange)" }}>// MISSION REQUEST</span>
                                    <h2 className="vk-cp-contact-heading">
                                        DEPLOY<br />
                                        <span style={{ color: "var(--vk-orange)" }}>YOUR TEAM</span>
                                    </h2>

                                    <div className="vk-cp-form">
                                        <div className="vk-cp-field-grid">
                                            {[
                                                { key: "company", ph: "Company Name", type: "text" },
                                                { key: "email", ph: "Work Email", type: "email" },
                                            ].map(({ key, ph, type }) => (
                                                <div key={key}>
                                                    <div className="vk-cp-field-label">{ph}</div>
                                                    <input
                                                        type={type}
                                                        placeholder={ph}
                                                        value={form[key]}
                                                        onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))}
                                                        className="vk-cp-input"
                                                    />
                                                </div>
                                            ))}
                                        </div>

                                        <div>
                                            <div className="vk-cp-field-label">HEADCOUNT</div>
                                            <div className="vk-cp-toggle-row">
                                                {["10–20", "20–50", "50–100", "100–200", "200+"].map(h => (
                                                    <button
                                                        key={h}
                                                        className={`vk-cp-toggle${form.headcount === h ? " active-orange" : ""}`}
                                                        onClick={() => setForm(p => ({ ...p, headcount: h }))}
                                                    >
                                                        {h}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <div>
                                            <div className="vk-cp-field-label">PACKAGE</div>
                                            <div className="vk-cp-toggle-row">
                                                {PACKAGES.map((p, i) => (
                                                    <button
                                                        key={p.id}
                                                        className="vk-cp-toggle"
                                                        style={active === i ? {
                                                            background: p.colorHex,
                                                            borderColor: p.colorHex,
                                                            color: "#060810",
                                                        } : {}}
                                                        onClick={() => setActive(i)}
                                                    >
                                                        {p.name}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <div>
                                            <div className="vk-cp-field-label">NOTES</div>
                                            <textarea
                                                placeholder="Dates, special requirements, branding..."
                                                value={form.notes}
                                                onChange={e => setForm(p => ({ ...p, notes: e.target.value }))}
                                                rows={2}
                                                className="vk-cp-input vk-cp-textarea"
                                            />
                                        </div>

                                        <button
                                            className="vk-cp-submit-btn"
                                            onClick={() => { if (form.company && form.email) setSent(true); }}
                                        >
                                            SUBMIT REQUEST ▶
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>

                {/* ─── RIGHT ─── */}
                <div className="vk-cp-right">
                    <span className="vk-cp-eyebrow" style={{ color: "var(--vk-orange)" }}>// HOW IT WORKS</span>

                    <div className="vk-cp-steps">
                        {STEPS.map((s, i) => (
                            <div key={i} className="vk-cp-step">
                                <div className="vk-cp-step-num">{s.n}</div>
                                <div>
                                    <div className="vk-cp-step-title">{s.t}</div>
                                    <div className="vk-cp-step-desc">{s.d}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="vk-cp-divider" />

                    <div>
                        <span className="vk-cp-eyebrow" style={{ color: "var(--vk-orange)" }}>// FIELD REPORT</span>
                        <div className="vk-cp-testimonial" style={{ borderLeftColor: pkg.colorHex }}>
                            <p className="vk-cp-testimonial-text">{TESTIMONIALS[active]}</p>
                            <div className="vk-cp-testimonial-credit" style={{ color: pkg.colorHex }}>
                                {TESTIMONIAL_CREDIT[active]}
                            </div>
                        </div>
                    </div>

                    <div className="vk-cp-contact-info">
                        <div className="vk-cp-contact-label">DIRECT LINE</div>
                        <div className="vk-cp-contact-text">
                            corporate@vegaskarts.com<br />
                            +1 (702) 000-0000
                        </div>
                    </div>
                </div>

            </div>

            {/* ══ BOTTOM BAR ══ */}
            <div className="vk-cp-bottombar">
                <span className="vk-cp-bottombar-text">VEGAS KARTS LLC · LAS VEGAS, NV</span>
                <span className="vk-cp-bottombar-text">WINTER 2026 · CORPORATE DIVISION</span>
            </div>

            <PanelNav prev={6} next={0} label="08 / 08 — EVENTS" onNav={onNav} />
        </section>
    );
}